import React, {useEffect, useRef, useState} from "react";
const HowToSection = () =>{

        const sectionRef = useRef(null);
        const [isVisible, setIsVisible] = useState(false);

        useEffect(() => {
                const observer = new IntersectionObserver(
                    ([entry]) => {
                            if (entry.isIntersecting) {
                                    setIsVisible(true);
                                    observer.unobserve(entry.target); // opzionale: anima solo la prima volta
                            }
                    },
                    { threshold: 0.3 } // parte dell’elemento visibile per attivarsi
                );

                if (sectionRef.current) {
                        observer.observe(sectionRef.current);
                }

                return () => {
                        if (sectionRef.current) {
                                observer.unobserve(sectionRef.current);
                        }
                };
        }, []);
    return (
        <section className="py-5">
                <div ref={sectionRef} className="container my-5">
                <div className="row text-center">
            <div className="col-md-4 mb-4">
                    <div className={`p-4 rounded h-100 fade-up ${isVisible ? 'visible fade-delay-1' : ''}`}>
            <i className="fas fa-user-plus fa-3x mb-3"></i>
            <h2 style={{'color' : '#ccc4a9'}}>Registrati</h2>
            <h5 className="mt-5">Registrati, inserisci i tuoi dati, crea il tuo profilo per inziare!</h5>
            </div>
            </div>
            <div className="col-md-4 mb-4">
                    <div className={`p-4 rounded h-100 fade-up ${isVisible ? 'visible fade-delay-2' : ''}`}>
            <i className="fas fa-shopping-cart fa-3x mb-3"></i>
                    <h2 style={{'color' : '#ccc4a9'}}>Acquista</h2>
            <h5 className="mt-5">Acquista il pacchetto minuti più adatto a te per poter parlare con un operatore!</h5>
            </div>
            </div>
            <div className="col-md-4 mb-4">
                    <div className={`p-4 rounded h-100 fade-up ${isVisible ? 'visible fade-delay-3' : ''}`}>
            <i className="fas fa-comments fa-3x mb-3"></i>
                    <h2 style={{'color' : '#ccc4a9'}}>Chatta</h2>
            <h5 className="mt-5">Richiedi di parlare con un operatore. Appena disponibile sarà lieto di parlate con te! </h5>
            </div>
            </div>
            </div>
            </div>
        </section>
    )
}

export default HowToSection;
